<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-text>
            <h6>SUNDAY OCTOBER 13TH, 2019
              <br><br>
              <v-divider insert></v-divider>
              <br>
              <i>
              Lunch, Drinks: 12 pm - 3 pm
              <br>
              </i>
              <br>
              <p>
                For those that can make it on Sunday, Anan and I are planning on inviting
                 people to our favorite Boston brewery, Night Shift.
              </p>
              <p>
                This will just be a really relaxing get together. They will have the <a href="https://www.complimentsfood.com/" target="_blank"> Compliments Food Truck</a> there as well. We will be there starting at 12pm on Sunday until about 3 pm.
              </p>
              <p>
                Feel free to stop in at any point if you can make it!
              </p>
              <a href="https://www.google.com/maps/place/Night+Shift+Brewing+-+Everett/@42.4059707,-71.067886,15z/data=!4m2!3m1!1s0x0:0xc68b7f0434ddb595?sa=X&ved=2ahUKEwiw8o6M7_bkAhWuneAKHdJOAu4Q_BIwGHoECAkQCA" target="_blank">
               87 Santilli Hwy, Everett, MA 02149
               </a>
            </h6>
          </v-card-text>
          <v-layout justify-center>
            <v-card-actions>
              <v-btn primary flat to="/directions" style="border: 1px solid grey;">
                <span>DIRECTIONS</span>
              </v-btn>
            </v-card-actions>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
export default {
  name: 'after-location-card',
};
</script>

<style scoped>
h1 {
  text-align: center;
  font: 5rem sans-serif;
}
h3 {
  text-align: center;
  font: 3rem sans-serif;
}
h4 {
  text-align: center;
  font: 2rem sans-serif;
}
h5 {
  text-align: center;
  font: 1.4rem sans-serif;
}
h6 {
  text-align: center;
  font: 1rem sans-serif;
}
h6 {
  text-align: center;
  font: 1rem sans-serif;
}

</style>
